window.FichaCrediario = Backbone.Model.extend({

});

window.FichasCrediario = Backbone.Collection.extend({
    model: FichaCrediario
});